import { fetchAgentValidation } from "../../connectors/AgentService";

const checkValidationSucceeded = (config) => {
    return config?.state === "SUCCESS";
}

const checkValidationCompleted = (config) => {
    return config?.state === "SUCCESS"
        || config?.state === "FAILED";
}

export default ({ dispatch, getState }) => next => async action => {
    const { type, payload } = action;

    if (type === "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS") {
        dispatch({
            type: "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS-PENDING"
        });
        const { agentId } = payload;
        const accountId = getState().tenancy.selectedAccountId;
        const response = await fetchAgentValidation(dispatch, agentId, accountId);
        const config = response?.data;

        const validationSucceeded = checkValidationSucceeded(config);
        const validationCompleted = checkValidationCompleted(config);
        if (validationSucceeded) {
            dispatch({
                type: "COMMON:VALIDATE-AGENT-LAST-RUN",
                payload: {
                    agentId
                }
            });
        }
        dispatch({
            type: "CONNECTOR-SETTINGS:GET-AGENT-VALIDATION-STATUS-SUCCESS",
            payload: {
                config,
                validationSucceeded,
                validationCompleted
            }
        });

    }

    return next(action);
}
